import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/smart/health/api/pas/back/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/smart/health/api/pas/back/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/smart/health/api/pas/back/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/smart/health/api/pas/back/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/smart/health/api/pas/back/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/smart/health/api/pas/back/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/smart/health/api/pas/back/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/smart/health/api/pas/back/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/smart/health/api/pas/back/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/smart/health/api/pas/back/admin/role/update',
    method: 'post',
    data: data
  })
}

export function getClientById(id) {
  return request({
    url: `/smart/health/api/pas/platform/client/GetClientById/${id}`,
    method: 'post'
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js